module.exports = __webpack_public_path__ + "static/media/avatars_all_7.05efe564.png";